import React from 'react';
import { Routes, Route } from 'react-router-dom';
import AdminPage from './components/AdminPage/index.js';
import ChartForm from './components/ChartForm/index.js';
import ChartDisplay from './components/ChartDisplay/index.js';
import Navbar from './components/Navbar/index.js';
import 'primereact/resources/themes/nova/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

const App = () => {
  return (
    <div>
      <Navbar />
      <Routes>
        <Route
          path="/"
          element={
            <>
              <ChartForm />
              <ChartDisplay />
            </>
          }
        />
        <Route path="/admin/*" element={<AdminPage />} />
      </Routes>
    </div>
  );
};

export default App;
